/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Notion_PricingInputs */

const en_mk_cmp_notion_pricing = /** @type {(inputs: Mk_Cmp_Notion_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free $0 · Plus $10 · Business $20 per seat per month · Enterprise by agreement. Custom Agents are billed per credit on top (≈ $10 per 1,000 credits).`)
};

const id_mk_cmp_notion_pricing = /** @type {(inputs: Mk_Cmp_Notion_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free $0 · Plus $10 · Business $20 per kursi per bulan · Enterprise sesuai kesepakatan. Custom Agents ditagih per kredit di atas paket (± $10 per 1.000 kredit).`)
};

/**
* | output |
* | --- |
* | "Free $0 · Plus $10 · Business $20 per seat per month · Enterprise by agreement. Custom Agents are billed per credit on top (≈ $10 per 1,000 credits)." |
*
* @param {Mk_Cmp_Notion_PricingInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_notion_pricing = /** @type {((inputs?: Mk_Cmp_Notion_PricingInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Notion_PricingInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_notion_pricing(inputs)
	return en_mk_cmp_notion_pricing(inputs)
});